import { render, staticRenderFns } from "./dlgEditor.vue?vue&type=template&id=f0a9970a&scoped=true&"
import script from "./dlgEditor.vue?vue&type=script&lang=js&"
export * from "./dlgEditor.vue?vue&type=script&lang=js&"
import style0 from "./dlgEditor.vue?vue&type=style&index=0&id=f0a9970a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a9970a",
  null
  
)

export default component.exports